import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Простейшее хранилище для последовательности команд
 *   персистентность отсутствует
 */
export var MemoryCommandStorage = /*#__PURE__*/function () {
  function MemoryCommandStorage() {
    _classCallCheck(this, MemoryCommandStorage);
    _defineProperty(this, "queue", []);
  }
  _createClass(MemoryCommandStorage, [{
    key: "push",
    value: function push(command) {
      this.queue.push(command);
    }
  }, {
    key: "all",
    value: function all() {
      return this.queue;
    }
  }]);
  return MemoryCommandStorage;
}();